<template>
  <div class="mt-12">
    <visitors-statistics
      class="mb-12"
      :loading="loading"
      :statistics="statistics.visitors"
    />

    <page-views-statistics
      class="mb-12"
      :loading="loading"
      :statistics="statistics.page_views"
    />
  </div>
</template>


<script>
import VisitorsStatistics from './Charts/Visitors/VisitorsStatistics';
import PageViewsStatistics from './Charts/PageViews/PageViewsStatistics';

export default {
  name: 'chart-statistics',
  props: ['statistics', 'loading'],
  components: { VisitorsStatistics, PageViewsStatistics },
}
</script>
